import { ErrorMessage, useFormikContext } from 'formik';
import PasswordStrengthBar from 'react-password-strength-bar';
import PropTypes from 'prop-types';
import PasswordField from '../password_field';

const ConfirmPasswordField = ({ passwordName, confirmPasswordName }) => {
  const { values } = useFormikContext();
  return (
    <>
      <div>
        <label className="form-label" htmlFor="newPassword">
          New password
        </label>
        <div>
          <PasswordField
            name={passwordName}
            id="newPassword"
            placeholder="New password"
          />
          <PasswordStrengthBar password={values[passwordName]} />
        </div>
        <ErrorMessage
          className="text-danger text-small mb-3"
          name={passwordName}
          component="div"
          id="newPassword_error"
        />
      </div>
      <div>
        <label className="form-label" htmlFor="confirmNewPassword">
          Confirm new password
        </label>
        <div>
          <PasswordField
            name={confirmPasswordName}
            id="confirmNewPassword"
            placeholder="Confirm new password"
          />
        </div>
        <ErrorMessage
          className="text-danger text-small mt-2"
          name={confirmPasswordName}
          component="div"
          id="confirmNewPassword_error"
        />
      </div>
    </>
  );
};

export default ConfirmPasswordField;

ConfirmPasswordField.propTypes = {
  passwordName: PropTypes.string.isRequired,
  confirmPasswordName: PropTypes.string.isRequired,
};
